<template>
  <div class="container">
    <div v-if="!isSystem">
      <div class="row" v-if="!isAuthor">
        <div class="col-11">
          <blockquote class="blockquote" style="background-color: #3d3f43;" :style="getStyle(comment)">
            <div class="row">
              <div class="col-md-12"><h4 style="font-size:12px; margin-bottom: 0;">{{employee_name}}</h4></div>
            </div>
            <div class="row" style="margin-top: -5px">
              <div class="col-md-12" style="margin-top: -5px"><code style="font-size: 10px; color: #e7050f">{{getTime(comment.date)}}</code></div>
            </div>
            <div class="row" style="">
              <div class="col-md-12" style=""><p>{{comment.text}}</p></div>
            </div>
          </blockquote>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-2 col-lg-1"><p></p></div>
        <div class="col-10 col-lg-11" style="">
          <blockquote class="blockquote" style="background-color: #84a8e7; float: right;" :style="getStyle(comment)">
            <div class="row" style="margin-top: -5px">
              <div class="col-md-12" style="margin-top: -5px;"><code style="font-size: 10px; color: #f7f01b">{{getTime(comment.date)}}</code></div>
            </div>
            <div class="row" style="">
              <div class="col-md-12" style=""><p style="color: #111111">{{comment.text}}</p></div>
            </div>
          </blockquote>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-12">
          <p style="font-size: 12px; color: #ffe4c447;">{{comment.text}}</p>
        </div>
      </div>
      <div class="row" style="margin-top: -10px">
        <div class="col-md-12">
          <p style="font-size: 12px; color: #ffe4c447;">{{getTime(comment.date)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "comment",
      props: ["comment", "isAuthor", "isSystem", "employee_name"],
      methods:{
        getTime(time){
          return new Date(time).toLocaleString();
        },
        getStyle(comment){
          return {
            "min-width"       : "150px",
            "width"           : this.getWidth(comment.text),
          }
        },
        getWidth(text){
          if (text.length < 17) {
            return (text.length * 10) + "px";
          }
          else{
            return "";
          }
        },
      },
    }
</script>

<style scoped>
  .blockquote{
    padding: 10px;

    border: 0;
    border-radius: 15px;
  }
</style>
